import { createApi } from "@reduxjs/toolkit/query/react";
import { appendFormData } from "helpers/functions";
import customFetchBase from "services/principal/customFetchBase";

export const fundamentoLegalApi = createApi({
  reducerPath: "fundamentoLegalApi",
  baseQuery: customFetchBase,
  tagTypes: ["FundamentoLegal"],
  endpoints: (builder) => ({
    getFundamentosLegales: builder.query({
      query: () => ({
        url: "/v1/api/fundamentolegal/",
        method: "GET",
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "FundamentoLegal",
                id,
              })),
              { type: "FundamentoLegal", id: "LIST" },
            ]
          : [{ type: "FundamentoLegal", id: "LIST" }],
    }),
    getFundamentoLegal: builder.query({
      query: (id) => ({
        url: `/v1/api/fundamentolegal/${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "FundamentoLegal", id }],
    }),
  }),
});

export const {
  useGetFundamentosLegalesQuery,
  useGetFundamentoLegalQuery,
  useCreateFundamentoLegalMutation,
  useUpdateFundamentoLegalMutation,
  useDeleteFundamentoLegalMutation,
} = fundamentoLegalApi;
